import { render } from "./ImgCarousel.vue?vue&type=template&id=310c97f2"
import script from "./ImgCarousel.vue?vue&type=script&lang=js"
export * from "./ImgCarousel.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__